import { between, alpha, minLength, required, minValue, maxLength, url, requiredIf, and, or, helpers } from 'vuelidate/lib/validators';

// Regex from node_modules\vuelidate\src\validators\url.js
// This is the regex used in the Vuelidate library's url 
// validator. The url method forced http/ftp - we will
// use the same regex and ensure rtmp/rtmps
const urlRegex = /^(?:(?:rtmps?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i
const rtmpUrl = helpers.regex('url', urlRegex)

export default {
  organization:{
    primaryContact:{
      firstName:{
        required
      },
      lastName:{
        required
      },
      phoneNumber:{
        minLength: minLength(10)
      }
    },
    name:{
      required
    },
    address:{
      country:{
        required
      },
      postalCode:{
        isValid: (value, vm) => {
          return validatePostalCode(value, vm.country);
        }
      }
    }
  },
  card:{
    card:{
      address:{
        country:{
          required
        },
        postalCode:{
          isValid: (value, vm) => {
            return validatePostalCode(value, vm.country);
          }
        }
      }
    }
  },
  channel:{
    codec:{
      opus:{
        bitrate:{
          minValue: minValue(1)
        }
      },
      vp8:{
        bitrate:{
          minValue: minValue(1)
        }
      },
      vp9:{
        bitrate:{
          minValue: minValue(1)
        }
      },
      h264:{
        bitrate:{
          minValue: minValue(1)
        }
      }
    },
    mcu:{
      audioInput:{
        maxBitrate: {
          between: between(1, 200)
        }
      },
      videoInput:{
        maxBitrate: {
          between: between(1, 20000)
        }
      },
      videoOutput:{
        width: {
          between: between(160, 1920)
        },
        height: {
          between: between(120, 1080)
        },
        frameRate: {
          between: between(1, 30)
        },
        layoutMargin: {
          minValue: minValue(1)
        }
      }
    },
    sfu:{
      audioInput:{
        maxBitrate: {
          between: between(1, 200)
        }
      },
      videoInput:{
        maxBitrate: {
          between: between(1, 20000)
        },
      }
    },
    videoEncodings:{
      maxLength: maxLength(3),
      $each: {
        bitrate: {
          between: between(100, 3000)
        },
        frameRate: {
          between: between(1, 30)
        },
        scale: {
          between: between(0.01, 1.00)
        }
      }
    },
    rtmp: {
      url: {
        requiredIfEnabled: requiredIf("enabled"),
        requiredIfSecretKeySet: requiredIf("secretKey"),
        validUrlIfNotEmpty: or(rtmpUrl, empty)
      },
      secretKey: {
        requiredIfEnabled: requiredIf("enabled"),
        requiredIfUrlSet: requiredIf("url"),
      }
    }
  }
};



function validatePostalCode(postalCode, country) {
  if (country == "US") {
    return /^[0-9]{5}(?:-[0-9]{4})?$/.test(postalCode);
  } else if (country == "CA") {
    return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(postalCode);
  }
  return true;
}

function empty(value) { return !value }
